<template>
    <b-container class="techExpertises">
        <b-row class="techExpertiseFlex">
            <b-col lg="6" sm="12">
                <img src="@/assets/imagesTech/techExpertise.png" alt="Expertises IT Jonction Lab">
            </b-col>
            <b-col lg="6" sm="12" class="techExpertiseContent">
                <p class="expertiseTitle bold">{{techExpertises.title}}</p>
                <ul>
                    <li v-for="(ex, i) in techExpertises.expertises" :key="i">
                        <img class="tecBullet" src="@/assets/imagesTech/techBullet.png" alt="bullet point">
                        {{ex}}
                    </li>
                </ul>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import json from '@/locales/en.json'

export default {
    name: "techExpertises",
    data: function() {
        return {
            techExpertises: json.pageTech.expertisesTech
        }
    }
}
</script>

<style lang="scss" scoped>
.techExpertises {
    padding: $maxi;
    border-radius: 25px;
    border: 5px solid $light;
}

.expertiseTitle{
    font-size: 36px;
}

.tecBullet {
    height:20px;
}

li {
    padding:10px 0;
    font-size:32px;
}

@media (max-width:765px) {
    .expertiseTitle{
        font-size:25px;
    }

    .techExpertises{
        padding: 15px;
        width:90%;
        margin-right:5%;
    }

    img {
        max-width: 90%;
        margin:auto;
    }

    ul {
        padding-inline-start: 0;
    }

    li {
        font-size:25px;
    }
}
</style>